import { Card, CardContent } from "@/components/ui";
import useApprovals from "./useFinance";
import { Heading } from "@/components";
import { ArrowRight } from "lucide-react";

const Approvals = () => {
  const { cardList } = useApprovals();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="Activity Dashboard" />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 mt-2 gap-5">
        {cardList.map((card: any) => {
          const Icon = card.icon;
          return (
            <Card
              key={card.title}
              className="h-[250px] w-auto rounded-xl border border-primary/15 bg-primary-300 shadow-sm transition-shadow hover:shadow-md cursor-pointer p-0 text-primary"
              onClick={card?.onClick}
            >
              <CardContent className="flex flex-col items-start h-full p-6">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary text-white">
                  <Icon className="h-8 w-8" aria-hidden="true" />
                </div>
                <h3 className="mt-4 text-xl font-semibold text-foreground">{card.title}</h3>
                <p className="mt-2 text-sm leading-5 text-muted-foreground">{card.description}</p>
                <div className="mt-auto flex w-full justify-end">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full border border-primary/20 bg-white/50 text-primary">
                  <ArrowRight className="h-5 w-5" aria-hidden="true" />
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default Approvals;
